export default function (value) {
    if (!value) {
        return '';
    }

    const trimmed = value.trim();

    // If it doesnt start with a p tag, just return it
    if (!/^<p[\s>]/.test(trimmed)) {
        return trimmed;
    }

    return trimmed.split('</p>')[0].split('>').slice(1).join('>');
}
